export default date => {
  const months = {
    monthShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    monthFull:
      'January_February_March_April_May_June_July_August_September_October_November_December'.split(
        '_'
      )
  }
  const tFormat = date.replace(/\s/g, 'T')
  const parseDate = new Date(tFormat)
  const day = parseDate.getDate()
  const month = parseDate.getMonth()
  const year = parseDate.getFullYear()
  const monthName = months.monthFull[month]

  return `${day} ${monthName} ${year}`
}
